<template>
  <router-link v-bind="$attrs" class="mt-6  d-flex align-center text-decoration-none">
    <BaseButton
      :ripple="false"
      depressed
      color="transparent"
      :height="32"
      class="px-0 mr-4"
      :style="{'min-width': '0px'}"
      small
    >
      <font-awesome-icon
        :icon="$vuetify.breakpoint.smAndDown ?
          'fa-regular fa-arrow-left': 'fa-regular fa-arrow-left-long'"
        :class="$vuetify.breakpoint.smAndDown ? 'brand-secondary--text' : 'neutral--text'"
        size="lg"
      />
    </BaseButton>
    <div
      :class="$vuetify.breakpoint.smAndDown ?
        'brand-secondary--text text-body-m' : 'neutral--text text-label-s-semi-bold'"
    >
      <slot />
    </div>
  </router-link>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'BaseBackButton',
  components: {
    BaseButton,
  },
};
</script>
